import React from 'react'
import {
  Box,
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  InputAdornment,
} from '@mui/material'
import { Search as SearchIcon } from '@mui/icons-material'
import { useGetBrandsQuery } from '@store/api/brandApi'

export interface HistoryFilterState {
  search: string
  brandId: string
  dateFrom: string
  dateTo: string
  rating: string
}

interface HistoryFiltersProps {
  filters: HistoryFilterState
  onChange: (filters: HistoryFilterState) => void
}

const HistoryFilters: React.FC<HistoryFiltersProps> = ({ filters, onChange }) => {
  const { data: brands = [] } = useGetBrandsQuery({})

  const update = (field: keyof HistoryFilterState) => (e: React.ChangeEvent<HTMLInputElement | { value: unknown }>) => {
    onChange({ ...filters, [field]: e.target.value as string })
  }

  return (
    <Box mb={3}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            fullWidth
            size="small"
            label="Search cigars or notes"
            value={filters.search}
            onChange={update('search')}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon fontSize="small" />
                </InputAdornment>
              ),
            }}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={2}>
          <FormControl fullWidth size="small">
            <InputLabel>Brand</InputLabel>
            <Select
              label="Brand"
              value={filters.brandId}
              onChange={(e) => onChange({ ...filters, brandId: e.target.value })}
            >
              <MenuItem value="">All Brands</MenuItem>
              {brands.map((brand) => (
                <MenuItem key={brand.id} value={brand.id}>
                  {brand.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={6} md={2}>
          <FormControl fullWidth size="small">
            <InputLabel>Rating</InputLabel>
            <Select
              label="Rating"
              value={filters.rating}
              onChange={(e) => onChange({ ...filters, rating: e.target.value })}
            >
              <MenuItem value="">Any Rating</MenuItem>
              <MenuItem value="5">5 Stars</MenuItem>
              <MenuItem value="4">4 Stars</MenuItem>
              <MenuItem value="3">3 Stars</MenuItem>
              <MenuItem value="2">2 Stars</MenuItem>
              <MenuItem value="1">1 Star</MenuItem>
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={6} md={2}>
          <TextField
            fullWidth
            size="small"
            label="From Date"
            type="date"
            value={filters.dateFrom}
            onChange={update('dateFrom')}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={2}>
          <TextField
            fullWidth
            size="small"
            label="To Date"
            type="date"
            value={filters.dateTo}
            onChange={update('dateTo')}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
      </Grid>
    </Box>
  )
}

export default HistoryFilters
